import type {SlotGameStore, BaseComponentConfig, ReelsetComponent} from "@gamzix/slot_core";

class BigWinComponent extends Game.src.component.BaseComponent {
    protected waitClick: () => Promise<void>;
    protected isWinAllLabel: boolean = false;
    protected timeWaitAfterEnd: number = 2000;
    protected percentSlow: number = 25;
    protected container;
    protected bigWin;
    protected text;

    protected multiplier = 20;

    static events = {
        START: "BigWinComponent.START_BIG_WIN",
        END: "BigWinComponent.END_POPUP",
        START_COUNT: "BigWinComponent.COUNTER_START",
        END_COUNT: "BigWinComponent.COUNTER_STOP"
    }

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isWinAllLabel: () => this.isWinAllLabel
        };
    }

    onGameReady() {
        game.once('SET_WAIT_CLICK', ({waitClick}) => this.waitClick = waitClick);

        super.onGameReady();

        this.bigWin = game.tree.findByName("bigwin.bigwin_texture");
        this.container = game.tree.findByName("bigwin.bigwin_container");
        this.text = game.tree.findByName("bigwin.bigwin_label");
    }

    checkBigWin(){
        if (this.store.gameData.spinWinAmount >= this.store.gameData.bet * this.multiplier){
            return true;
        }
    }

    get reelset(): ReelsetComponent {
        return <any>game.component.reelset;
    }

    async showBigWinTexturePopup() {
        game.utils.GameUtils.playAlphaAnimation(this.container, {from: 0, to: 1, time: 300, timeWait: 0});

        await game.utils.GameUtils.playScaleToAnimation(this.bigWin, {scaleFrom: 0, scaleTo: 1.12, time: 750});
        await game.utils.GameUtils.playScaleToAnimation(this.bigWin, {scaleFrom: 1.12, scaleTo: 1, time: 1200});
    }

    async showStartBigWinPopup() {
        this.showBigWinTexturePopup();

        game.emit(BigWinComponent.events.START);
        game.emit(BigWinComponent.events.START_COUNT);

        const spinWinAmount = this.store.gameData.spinWinAmount;
        const spinWinAmountSlow = spinWinAmount / 100 * this.percentSlow;

        if (!this.store.gameSettings.isFastSpin) {
            await Promise.race([
                this.waitClick(),
                game.onceDataPromise('Button.clicked', { component: 'bigWin', name: 'bigWin.click_button'}),
                game.utils.GameUtils.playCounterAnimation(this.text, { from: 0, to: spinWinAmount - spinWinAmountSlow, time: 2000, timeWait: 0, ease: createjs.Ease.linear })
                    .then(() => game.utils.GameUtils.playCounterAnimation(this.text, { from: spinWinAmount - spinWinAmountSlow, to: spinWinAmount, time: 2000, timeWait: 0, ease: createjs.Ease.getPowOut(4) }))
            ]);
        }

        game.utils.removeCall(this.text._tween);

        this.text.options.text = this.store.toFormatMoney(this.store.gameData.spinWinAmount);
        this.text.updateViewOptions();

        game.emit(BigWinComponent.events.END_COUNT);
        game.emit(BigWinComponent.events.END);

        await game.utils.delay(this.timeWaitAfterEnd);
    }

    async hideBigWinPopup() {
        await game.utils.GameUtils.playAlphaAnimation(this.container, {from: 1, to: 0, time: 300, timeWait: 0});

        this.text.options.text = "";
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    getFSMHandlers() {
        return {
            SHOW_WIN: {
                showBigWin: {
                    on: async () => {
                        this.reelset.playAllWinsLoopAnimation();

                        this.isWinAllLabel = true;

                        await this.showStartBigWinPopup();
                        await this.hideBigWinPopup();

                        this.reelset.playAllIdleAnimation();
                    },
                    check: ()=> this.checkBigWin()
                }
            }
        }
    }

}

//@ts-ignore
Game.src.component.BigWinComponent = BigWinComponent;
